export default __webpack_public_path__ + "static/media/Blade's Boots of Creeping Death.aebf8cbe.jpg";